import { render, staticRenderFns } from "./ClueList.vue?vue&type=template&id=635524e5&scoped=true&"
import script from "./ClueList.vue?vue&type=script&lang=js&"
export * from "./ClueList.vue?vue&type=script&lang=js&"
import style0 from "./ClueList.vue?vue&type=style&index=0&id=635524e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635524e5",
  null
  
)

export default component.exports